import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfigService } from 'src/app/shared/services/config.service';
import { SnackBarService } from '../../../shared/snack-bar/services/snack-bar.service';
import { basicSnackBarConfig } from 'src/app/utils/default-configs/configuration';

@Component({
  selector: 'app-autoprintlabel',
  templateUrl: './autoprintlabel.component.html',
  styleUrls: ['./autoprintlabel.component.css'],
})
export class AutoprintlabelComponent implements OnInit {
  autoGenerateLabelList = ['Yes', 'No'];
  autoGenerateLabelGroup: FormGroup;
  constructor(
    private configService: ConfigService,
    private fb: FormBuilder,
    private snackBarService: SnackBarService
  ) {}

  ngOnInit(): void {
    this.intialiseAutoGenerateGroup();
    this.getAutoPrintLabelConfig();
  }

  intialiseAutoGenerateGroup() {
    this.autoGenerateLabelGroup = this.fb.group({
      autoPrint: new FormControl('', Validators.compose([Validators.required])),
    });
  }

  getAutoPrintLabelConfig() {
    this.configService.fetchConfig('auto_print_labels').then(res => {
      if (res.data) {
        this.autoGenerateLabelGroup
          .get('autoPrint')
          .patchValue(res.data[0].autoPrint == true ? 'Yes' : 'No');
      }
    });
  }
  saveAutoGenerateLabel() {
    let b: boolean = this.autoGenerateLabelGroup.value.autoPrint === 'Yes';
    const configData = {
      config_id: 'auto_print_labels',
      data: [{ autoPrint: b }],
    };
    this.saveConfig(configData);
  }

  saveConfig(config: any) {
    this.configService.saveConfig(config).subscribe(res => {
      this.snackBarService.createSnackBar(
        basicSnackBarConfig.addressComponentSave?.message,
        basicSnackBarConfig.addressComponentSave?.horizontalPosition,
        basicSnackBarConfig.addressComponentSave?.verticalPosition,
        basicSnackBarConfig.addressComponentSave?.duration
      );
      if (res) {
        this.configService.putConfig(config.config_id, res['data']);
      }
    });
  }
}
